import React from 'react';
import { motion } from 'framer-motion';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-neutral-900 to-black text-white py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-gradient">Terms of Service</h1>
          <p className="text-neutral-400 mb-12">Last updated: November 4, 2025</p>

          <div className="space-y-8 text-neutral-300">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Agreement to Terms</h2>
              <p className="leading-relaxed">
                By accessing or using the CDO Nepal USA website, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using this site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">About CDO Nepal USA</h2>
              <p className="leading-relaxed">
                CDO Nepal USA is a 501(c)(3) nonprofit organization that serves as the United States fundraising office for Care Development Organization Nepal (CDO Nepal). Our mission is to support sustainable development programs in Nepal's most remote villages.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Donations</h2>
              <p className="leading-relaxed mb-4">
                When you make a donation through our website:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>All donations are final and non-refundable, except as required by law</li>
                <li>Donations are tax-deductible to the extent allowed by law</li>
                <li>You will receive a receipt for tax purposes via email</li>
                <li>Donations will be used to support our active programs as described on our website</li>
                <li>We reserve the right to use donations where they are most needed</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Use of Website</h2>
              <p className="leading-relaxed mb-4">You agree not to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Use the website for any unlawful purpose</li>
                <li>Attempt to gain unauthorized access to any portion of the website</li>
                <li>Interfere with or disrupt the website's functionality</li>
                <li>Reproduce, duplicate, or copy material from the website without permission</li>
                <li>Use automated systems to access the website without our consent</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Intellectual Property</h2>
              <p className="leading-relaxed">
                All content on this website, including text, graphics, logos, images, and software, is the property of CDO Nepal USA or its content suppliers and is protected by intellectual property laws. Unauthorized use is prohibited.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">External Links</h2>
              <p className="leading-relaxed">
                Our website may contain links to third-party websites. We are not responsible for the content, privacy policies, or practices of these external sites. We recommend reviewing their terms and policies before engaging with them.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Disclaimer of Warranties</h2>
              <p className="leading-relaxed">
                This website is provided "as is" without warranties of any kind, either express or implied. We do not warrant that the website will be uninterrupted, error-free, or free of viruses or other harmful components.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Limitation of Liability</h2>
              <p className="leading-relaxed">
                CDO Nepal USA shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the website, even if we have been advised of the possibility of such damages.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Indemnification</h2>
              <p className="leading-relaxed">
                You agree to indemnify and hold harmless CDO Nepal USA and its officers, directors, employees, and agents from any claims, damages, losses, liabilities, and expenses arising out of your use of the website or violation of these Terms of Service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Tax Information</h2>
              <p className="leading-relaxed">
                CDO Nepal USA is a 501(c)(3) tax-exempt organization. Donations are tax-deductible to the extent permitted by law. Our Tax ID (EIN) is available upon request. Please consult with your tax advisor regarding the deductibility of your donation.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Governing Law</h2>
              <p className="leading-relaxed">
                These Terms of Service shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Changes to Terms</h2>
              <p className="leading-relaxed">
                We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to the website. Your continued use of the website after changes are posted constitutes acceptance of the modified terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Contact Information</h2>
              <p className="leading-relaxed">
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <p className="leading-relaxed mt-4">
                Email: <a href="mailto:info@cdonepal.org" className="text-amber-400 hover:text-amber-300">info@cdonepal.org</a>
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsOfService;

